import Add from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { Divider, IconButton } from "@mui/material";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import React from "react";
import BSInput from "../../../common/js/components/BSInput";
import utilOperations from "../utils/operations";
import ExhibitADetail from "./ExhibitADetail";

const StyledRootButton = styled(Button)({
    border: "2px dashed #2C99D2",
    color: "#2C99D2",
    margin: "10px 0 20px",
    padding: "11px 16px",
    width: "100%",
    justifyContent: "start",
    "&:hover": {
        backgroundColor: "rgba(44, 153, 210, 0.08)",
    },
});

const StyledArchiveExhibitAButton = styled(Button)({
    marginBottom: "10px",
});

const StyledTable = styled("table")({
    borderCollapse: "collapse",
    width: "100%",
});

const StyledArchiveLabel = styled("span")({
    color: "rgba(0, 0, 0, 0.6)",
    fontWeight: "600",
    fontSize: "13px",
    marginRight: "5px",
    minWidth: "100px",
    maxWidth: "100px",
});

const StyledValue = styled("span")({
    fontWeight: "400",
    fontSize: "13px",
});

const StyledArchiveContainer = styled("div")({
    display: "flex",
    minWidth: "150px",
});

const ExhibitAInformation = (props) => {
    const {
        editableExhibitAs,
        archivedExhibitAs,
        handlePrependArrayElement,
        handleDeleteArrayElement,
        handleUpdateArrayElement,
    } = props;

    const [expandArchivedExhibitA, setExpandArchivedExhibitA] = React.useState(false);
    const archivedExhibitAText = expandArchivedExhibitA ? "Hide Archived Exhibit As" : "Show Archived Exhibit As";

    return (
        <div>
            {editableExhibitAs.length > 0 &&
                editableExhibitAs.map((element, index) => {
                    return (
                        <ExhibitADetail
                            key={`new-exhibit-${element["exhibitAKey"] || index}`}
                            element={element}
                            elementIndex={index}
                            onDelete={handleDeleteArrayElement}
                            handleUpdateArrayElement={handleUpdateArrayElement}
                            {...props}
                        />
                    );
                })}
            <StyledRootButton
                onClick={() => {
                    handlePrependArrayElement("editableExhibitAs");
                }}
            >
                <Add />
                {"Add Exhibit A"}
            </StyledRootButton>
            <StyledArchiveExhibitAButton
                color="primary"
                variant="contained"
                disabled={archivedExhibitAs?.length === 0}
                onClick={() => setExpandArchivedExhibitA(!expandArchivedExhibitA)}
            >
                {archivedExhibitAText}
            </StyledArchiveExhibitAButton>

            {expandArchivedExhibitA &&
                archivedExhibitAs.map((element, index) => {
                    return (
                        <React.Fragment key={`archived-exhibit-${element["exhibitAKey"] || index}`}>
                            <StyledTable>
                                <tbody>
                                    <tr>
                                        <td>
                                            <IconButton
                                                sx={{ padding: 0, minWidth: 0, margin: 0 }}
                                                onClick={() => {
                                                    handleDeleteArrayElement("archivedExhibitAs", index);
                                                }}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </td>
                                    </tr>
                                    <tr>
                                        <StyledArchiveLabel>{element["exhibitAType"]}</StyledArchiveLabel>
                                    </tr>
                                    <tr>
                                        <td>
                                            <StyledArchiveContainer>
                                                <StyledArchiveLabel>BASE SPLIT %</StyledArchiveLabel>
                                                <StyledValue>{parseInt(element["baseSplitPercentage"])}</StyledValue>
                                            </StyledArchiveContainer>
                                        </td>
                                        <td>
                                            <StyledArchiveContainer>
                                                <StyledArchiveLabel>ANNUAL GROSS MINIMUM</StyledArchiveLabel>
                                                <StyledValue>
                                                    {utilOperations.formatAmount(element["annualGrossMinimum"])}
                                                </StyledValue>
                                            </StyledArchiveContainer>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <StyledArchiveContainer>
                                                <StyledArchiveLabel>ADJUSTED %</StyledArchiveLabel>
                                                <StyledValue>
                                                    {parseInt(element["adjustedPercentage"]).toFixed(2)}
                                                </StyledValue>
                                            </StyledArchiveContainer>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <StyledArchiveContainer>
                                                <StyledArchiveLabel>START DATE</StyledArchiveLabel>
                                                <StyledValue>
                                                    {utilOperations.formatDate("MM-DD-YYYY")(
                                                        element["exhibitAStartDate"]
                                                    )}
                                                </StyledValue>
                                            </StyledArchiveContainer>
                                        </td>
                                        <td>
                                            <StyledArchiveContainer>
                                                <StyledArchiveLabel>EXPIRATION DATE</StyledArchiveLabel>
                                                <StyledValue>
                                                    {utilOperations.formatDate("MM-DD-YYYY")(
                                                        element["exhibitAExpirationDate"]
                                                    )}
                                                </StyledValue>
                                            </StyledArchiveContainer>
                                        </td>
                                    </tr>
                                </tbody>
                            </StyledTable>
                            <BSInput
                                id="comments"
                                placeholder="Enter comments"
                                value={element["comments"]}
                                multiline
                                rows={5}
                                margin="normal"
                                variant="outlined"
                                disabled={true}
                                label="COMMENTS"
                            />
                            <Divider flexItem />
                        </React.Fragment>
                    );
                })}
        </div>
    );
};

export default ExhibitAInformation;
